export default { 
  
  partida_selecionada (state) {
    return state.partida
  },

  partidaIndex (state) {
    return state.index
  }
}